import axios from 'axios'

const API_URL =  import.meta.env.VITE_NEXTQUEST_API_URL || 'https://localhost:7020'

const rawgApi = {
  searchGames: async (
    query: string,
    page = 1,
    genre = ''
  ) => {
    let url =
      `${API_URL}/api/Rawg/search?query=${encodeURIComponent(query)}&page=${page}`

    if (genre) {
      url += `&genre=${encodeURIComponent(genre)}`
    }

    return axios.get(url)
  },

  getFeaturedGames: async (page = 1, pageSize = 24) => {
    try {
      return await axios.get(
        `${API_URL}/api/Rawg/featured?page=${page}&pageSize=${pageSize}`
      )
    } catch {
      return axios.get(`${API_URL}/api/Rawg/search?query=popular`)
    }
  },

  getGenres: async () => {
  return axios.get(`${API_URL}/api/Rawg/genres`)
},

  getGameDetails: async (id: number) => {
    return axios.get(`${API_URL}/api/Rawg/details/${id}`)
  },

  getGameScreenshots: async (id: number) => {
    return axios.get(`${API_URL}/api/Rawg/screenshots/${id}`)
  },

  getGameMovies: async (id: number) => {
    return axios.get(`${API_URL}/api/Rawg/movies/${id}`)
  }
}

export default rawgApi